module.exports = __webpack_public_path__ + "img/syukyaku-dtp-ira001.cf055e8a.png";